import {
  string,
  number,
  object,
  boolean,
  collection,
  array,
} from '@gogame/schemas';

import { PLATFORMS } from 'scenes/Influencers/InfluencersCampaigns/components/InfluencerCampaignForm/constants';

import {
  PLATFORM_ID,
  ADDITIONAL_PARAMS,
  VISIBLE_PARAMS,
  AD_GROUP_ID,
  CAMPAIGN_ID,
  CONDITIONAL_REWARD_IDS,
  EXPIRATION_DATE,
  HYBRID_LINK_PARAMETERS,
  IOS_CPP,
  ANDROID_CPP,
} from './constants';

export const ggCampaignLinkSchema = object({
  [PLATFORM_ID]: number(),
  [ADDITIONAL_PARAMS]: string().nullable(),
  [VISIBLE_PARAMS]: object({
    [AD_GROUP_ID]: boolean(),
    [CAMPAIGN_ID]: boolean(),
    [CONDITIONAL_REWARD_IDS]: boolean(),
  }),
});

export const ggCampaignLinksSchema = object({
  [PLATFORMS]: collection(ggCampaignLinkSchema)
    .min(1, 'Platforms is required')
    .required('Platforms is required'),
  [EXPIRATION_DATE]: string().nullable(),
  [HYBRID_LINK_PARAMETERS]: object({
    [IOS_CPP]: array(string().required('Parameter is required')),
    [ANDROID_CPP]: array(string().required('Parameter is required')),
  }),
});
